
export function createByteArray(url) {
  var byteArray = [];
  var req = new XMLHttpRequest();
  req.open("GET", url, false);
  req.overrideMimeType("text/plain; charset=x-user-defined");
  req.send(null);
  if (req.status !== 200) return byteArray;
  for (var i = 0; i < req.responseText.length; ++i) {
    byteArray.push(req.responseText.charCodeAt(i) & 0xff);
  }
  return byteArray;
}

export function formatDateDDMMYYYYHHMM(time) {
  let date = new Date(time);
  return (
    date.toLocaleDateString([], { day:"2-digit", month: "2-digit", year:"numeric"}) +
    " " +
    date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })
  );
}

export function formatDateHHMM(time) {
  let date = new Date(time);
  return (
    date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })
  );
}

export function formatDateDDMMYYYYT0000(time) {
  let date = new Date(time);
  return date.toISOString().split("T")[0] + "T00:00";
}


export function formatDateDDMMYYYY(time) {
  let date = new Date(time);
  return date.toLocaleDateString([], { day:"2-digit", month: "2-digit", year:"numeric"});
}


